import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { LIVE, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../../utils/style';
import { HEIGHT as INCENTIVE_HEIGHT } from '../pill/pill.style';

export const defaultContext = makeDefaultStylingContext();

export const HEIGHT = {
  [HD]: 32,
  [FULL_HD]: 32,
};

export const getTextStyle = screenSize => ({
  ...getFont(FONT.BERLIN_2, screenSize),
  verticalAlign: 'middle',
});

export const colors = {
  incentive: makeThemeColor(LIVE),
};

export const getInitialStyle = ({ colorMode, screenSize } = defaultContext) => ({
  Current: {
    backgroundColor: colors.incentive[colorMode],
    y: Math.round((HEIGHT[screenSize] - INCENTIVE_HEIGHT[screenSize]) / 2),
  },
});
